// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"4e236fc4","205":"83aa57ac","209":"38ac4262","508":"d06cc04b","551":"c2ddb01f","629":"c65ea7c9","672":"9f3c38fc","842":"01821987","851":"3f0086ba"}[chunkId] + ".chunk.js";
};